import BaseCommand from "@/models/api/commands/BaseCommand";

export class SaleDateChangeCommand extends BaseCommand {
  CommandName = "SaleDateChange";
  Command: string;
  constructor(sessionId: string, operationId: string, saleDate: string) {
    super(sessionId, operationId);
    this.Command = saleDate;
  }
}
